<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div>
              <strong>こちらの内容で変更します。よろしいですか？</strong>
              <div class="mt-3">
                <div class="mb-3">
                  <h4>注意・制限事項</h4>
                  <div class="mt-2">
                    ・UntagサイトにおいてVNコネクトを有効化した場合、VNコネクトを有効化していないVLAN
                    IDの通信はすべて破棄されます。<br />
                    ・OtherサイトにおいてVNコネクトを有効化した場合、VNコネクトを有効化していないVLAN
                    IDの通信はすべてOtherのL2VNに転送されます。
                  </div>
                </div>
                <v-table density="compact" class="table">
                  <thead>
                    <tr>
                      <th class="text-center">VNコネクト番号</th>
                      <th class="text-center">変更後の状態</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="wnumber in wnumbers" :key="wnumber">
                      <td>{{ wnumber }}</td>
                      <td>{{ status }}</td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <!-- 「はい」ボタン押下時、状態変更を行う -->
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "VNConnectStatusModify",
  props: {
    wnumbers: {
      type: Array as PropType<string[]>,
      required: true,
    },
    status: {
      type: String as PropType<string>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.table th {
  background-color: #e9ecef;
  font-weight: bold !important;
}
</style>
